import { graphql } from '@graphql/gql';

export const CHECK_ATTENDEE_HAS_CHANNELS = graphql(`
  query CHECK_ATTENDEE_HAS_CHANNELS {
    checkAttendeeHasChannels {
      hasChannels
      status
      limit
      remaining
      resetAt
    }
  }
`);
